import {
	SHOW_BOT_LOADING,
	SET_NODE,
	SET_BOT_FLOW,
	SET_STORY,
	SET_BOT_ACCOUNTS,
	SAVE_BOT_ACCOUNTS,
	RESET_BOTFLOW,
	SET_BOT_FLOW_TEMPLATES,
	SAVE_BOT_INTREGATIONS,
	SHOW_EMOJI_PICKER,
	SHOW_PERSONALIZED_PICKER,
	SHOW_BOT_MENU
} from "../constants/BotFlow";

const initState = {
	loading: true,
	nodes: [],
	picker:{
		visible : false,
		position : {
			top: 0,
			left:0
		}
	},
	personalizer : {
		visible : false,
		position : {
			top: 0,
			left:0
		}
	},
	menu:{
		visible : false,
		position : {
			top: 0,
			left:0
		}
	},
	sessionVariables: [],
	accounts: [],
	selectedStory: "root",
	userBotAccounts: [],
	botFlowTemplates: [],
	botIntegrations: [
		{
			integration_type: "zoho",
			integration_icon:
				"https://uploads-ssl.webflow.com/594d8d64dc2b583adddea915/5a7fd806c7942700013399da_zoho.png",
		},
		{
			integration_type: "leadSquare",
			integration_icon:
				"https://lmksuo59r52jxjjy13j6oyze-wpengine.netdna-ssl.com/marketing-automation/files/2021/10/LeadSquared-logo.png",
		},
	],
	botIntegrationSettingsDetails: {},
};

const botflow = (state = initState, action) => {
	// console.log("ACTION", action);
	switch (action.type) {
		case SHOW_EMOJI_PICKER: {
			return {
				...state,
				picker: action.payload,
			};
		}
		case SHOW_PERSONALIZED_PICKER: {
			return {
				...state,
				personalizer: action.payload,
			};
		}
		case SHOW_BOT_MENU: {
			return {
				...state,
				menu: action.payload,
			};
		}
		case SHOW_BOT_LOADING: {
			return {
				...state,
				loading: action.payload,
			};
		}
		case SET_NODE: {
			return {
				...state,
				nodes: action.payload,
			};
		}
		case RESET_BOTFLOW: {
			return {
				loading: false,
				nodes: [],
				sessionVariables: [],
				accounts: [],
				selectedStory: "root",
				userBotAccounts: [],
			};
		}
		case SET_STORY: {
			return {
				...state,
				selectedStory: action.payload,
			};
		}
		case SET_BOT_FLOW: {
			return {
				...state,
				nodes: action.payload.nodes,
			};
		}
		case SET_BOT_ACCOUNTS: {
			return {
				...state,
				accounts: action.payload,
			};
		}
		case SAVE_BOT_ACCOUNTS: {
			return {
				...state,
				userBotAccounts: action.payload,
			};
		}
		case SET_BOT_FLOW_TEMPLATES: {
			return {
				...state,
				botFlowTemplates: [...action.payload],
			};
		}
		case SAVE_BOT_INTREGATIONS: {
			let integrationDetails = {};
			action.payload.forEach((integration) => {
				integrationDetails[integration.integration_type] = integration.integration_functions;
				delete integration.integration_functions;
			});
			return {
				...state,
				botIntegrations: [...action.payload],
				botIntegrationSettingsDetails: { ...integrationDetails },
			};
		}
		default:
			return state;
	}
};

export default botflow;
